var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto"},[_c('plotly',{attrs:{"data":_vm.plotlyData.data,"layout":_vm.plotlyData.layout,"display-mode-bar":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }